import { Button, Dropdown, Icon, Image, Typography } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LinkBox } from '@hero/components/molecules';
import { shareLinks } from '@hero/data';

import * as S from './style';

const shareDropdownOptions = {
  modifiers: [
    {
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, 16]
      }
    },
    {
      name: 'flip',
      enabled: true,
      options: {
        padding: 24,
        rootBoundary: 'viewport',
        allowedAutoPlacements: ['right-start', 'right-end', 'left-start', 'left-end']
      }
    }
  ]
};

function ShareLinkDropdown({
  headerTitle = 'Share gift link',
  link,
  placement = 'left-end',
  onCopy,
  shareButtonVariant = 'text'
}) {
  const [showAll, setShowAll] = useState(false);
  const { t } = useTranslation();

  return (
    <Dropdown
      popperOptions={{
        placement: placement,
        ...shareDropdownOptions
      }}
      style={{
        zIndex: 4
      }}
      referenceComponent={({ setIsMenuOpen }) => (
        <Button
          startIcon={<Icon name="upload" />}
          variant={shareButtonVariant}
          color="primary"
          onClick={() => setIsMenuOpen(true)}
        >
          {t('share')}
        </Button>
      )}
    >
      {({ setIsMenuOpen }) => (
        <S.ShareLinkDropdown>
          <S.Header>
            <S.TextLabel variant="body2Bold">
              <Icon as="span" name="link" />
              {headerTitle}
            </S.TextLabel>
            <Button variant="link" onClick={() => setIsMenuOpen(false)}>
              <Icon name="close" color="var(--color-neutral-800)" />
            </Button>
          </S.Header>

          <S.ShareLinks>
            {shareLinks.map(({ name, label, logo, share }, index) => {
              if (!showAll && index > 3) return null;

              return (
                <S.ShareLink
                  key={name}
                  href={share(link)}
                  target="_blank"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <Image src={logo} alt={name} width={24} height={24} />
                  <S.ShareLinkText>{label}</S.ShareLinkText>
                </S.ShareLink>
              );
            })}
            <S.ShareLinksSeeMore
              variant="link"
              color="neutral"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll ? t('seeLess') : t('seeMore')}
            </S.ShareLinksSeeMore>
          </S.ShareLinks>

          <S.ShareCopy>
            <Typography color="neutral" variant="body2" style={{ marginBottom: '8px' }}>
              {t('orCopyLink')}:
            </Typography>

            <LinkBox link={link} onCopy={onCopy} />
          </S.ShareCopy>
        </S.ShareLinkDropdown>
      )}
    </Dropdown>
  );
}

export { ShareLinkDropdown };
